import React, { useState, useEffect } from 'react';
import { Box, Typography } from "@mui/material";
import axios from "axios";
import { API_URL } from "../../api-config";
import { TVChartContainerPriceMonitor } from '../../components/TVChartContainer/price_monitor';
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const PriceMonitor = () => {
    const [stallStatus, setStallStatus] = useState(null);

    useEffect(() => {
        const checkStatus = async () => {
            try {
                const res = await axios.get(`${API_URL}/usdclp-api/control/status`);
                setStallStatus(res.data);
            } catch (e) {
                // Silencioso en monitor
            }
        };
        checkStatus();
        const interval = setInterval(checkStatus, 5000);
        return () => clearInterval(interval);
    }, []);

    const isStalled = stallStatus?.is_stalled;

    return (
        <Box m="20px" height="75vh" display="flex" flexDirection="column">
            <Box display="flex" justifyContent="space-between" alignItems="center" mb="10px">
                <Typography variant="h4" fontWeight="bold">
                    Real-Time Price Monitor
                </Typography>
                {stallStatus && (
                    <Box display="flex" alignItems="center" gap="10px">
                        <span className="text-xs px-2.5 py-1 rounded bg-gray-800 text-cyan-400 border border-gray-700 font-mono">
                            Modo: <strong>{stallStatus.price_mode?.toUpperCase()}</strong>
                        </span>
                    </Box>
                )}
            </Box>

            {isStalled && (
                <div className="bg-red-950/80 border-2 border-red-500 rounded-lg p-3 mb-3 flex items-center justify-between shadow-lg text-red-200 animate-pulse">
                    <div className="flex items-center gap-2">
                        <WarningAmberIcon className="text-red-400" />
                        <span className="text-sm font-bold">
                            ⚠️ ATENCIÓN: ENVÍO DE PRECIO EN STALL (OneZeroConn)
                        </span>
                        <span className="text-xs text-red-300">
                            — La transmisión automática está pausada para dealeo manual.
                        </span>
                    </div>
                    {stallStatus.stall_remaining_seconds > 0 && (
                        <span className="text-xs font-mono font-bold bg-red-900/60 px-2 py-1 rounded border border-red-700">
                            Restante: {Math.floor(stallStatus.stall_remaining_seconds / 60)}m {stallStatus.stall_remaining_seconds % 60}s
                        </span>
                    )}
                </div>
            )}

            <Box flexGrow={1} bgcolor="#131722" borderRadius="8px" overflow="hidden" p="10px">
                <TVChartContainerPriceMonitor />
            </Box>
        </Box>
    );
};

export default PriceMonitor;
